var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCouponBgImg01Pc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 380 68"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2E2E2E",
  d: "M380 26.02a7 7 0 0 0-.5-.02c-4.142 0-7.5 3.582-7.5 8s3.358 8 7.5 8q.252-.002.5-.02V68H0V0h380z"
})));
export default SvgCouponBgImg01Pc;